import { useParams, Navigate } from "react-router-dom";
import PartnerLanding from "@/components/PartnerLanding";
import { getPartner } from "@/lib/partners";

export default function Partner() {
  const { slug } = useParams();
  const partner = getPartner(slug);
  if (!partner) return <Navigate to="/" replace />;
  return <PartnerLanding partner={partner} />;
}
